// removed by extract-text-webpack-plugin
module.exports = {"Select-animation-fadeIn":"base__Select-animation-fadeIn___iaRMp","Select-animation-spin":"base__Select-animation-spin___3QnF_"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/base.css
// module id = 1538
// module chunks = 0